<app-draggable-modal-wrapper>
    <div class="py-10">
        <span
            class="!flex !justify-center !items-center !text-4xl !text-success-700 !font-normal text-center"
            mat-dialog-title
            >{{ data.title }}</span
        >
        <mat-dialog-content class="!flex !justify-center !items-center !mt-8">
            <img src="assets/svg/green-check-mark.svg" alt="green check mark" />
        </mat-dialog-content>
        <mat-dialog-actions align="center">
            @if (data.primaryAction) {
                <button
                    class="!rounded-lg !font-normal !w-50p"
                    color="primary"
                    type="button"
                    (click)="data.primaryAction.action()"
                    mat-raised-button
                    mat-dialog-close
                    cdkFocusInitial
                >
                    {{ data.primaryAction.title }}
                </button>
            }
        </mat-dialog-actions>
        @if (data.content) {
            <div class="flex items-center justify-center w-full mt-3">
                <p
                    class="text-center text-base text-tertiary-900"
                    [innerHtml]="data.content"
                ></p>
            </div>
        }
    </div>
</app-draggable-modal-wrapper>
